import { useId } from "react";
import {
  buildResizeCornerLabel,
  RESIZE_CORNERS,
} from "@/features/thread/components/desktop/desktopPanelResizeCorner";
import type {
  PanelResizeCorner,
  ResizeHandleProps,
} from "@/shared/hooks/useDraggablePanel";

interface Props {
  /** 「新規スレッドフォーム」など、アクセシブル名の前置きに使うパネル名。 */
  panelLabel: string;
  handleProps: Record<PanelResizeCorner, ResizeHandleProps>;
}

const RESIZE_HINT =
  "ドラッグ、または矢印キーでサイズを変更できます。Shiftを押しながらで大きく動き、Homeで既定のサイズと位置に戻ります。";

/**
 * フローティングフォームの隅に置くサイズ変更ハンドル。
 *
 * 三角形の見た目は内側の span が担う。button 自体に clip-path を掛けると
 * :focus-visible のアウトラインまで切り取られ、フォーカス位置が見えなくなる。
 */
export const DesktopPanelResizeCorners: React.FunctionComponent<Props> = ({
  panelLabel,
  handleProps,
}: Props) => {
  const hintId = useId();

  return (
    <>
      <p id={hintId} className="sr-only">
        {RESIZE_HINT}
      </p>
      {RESIZE_CORNERS.map((corner: PanelResizeCorner) => (
        <button
          key={corner}
          type="button"
          className="desktop-floating-resize-corner"
          data-corner={corner}
          aria-label={buildResizeCornerLabel(panelLabel, corner)}
          aria-describedby={hintId}
          title={RESIZE_HINT}
          {...handleProps[corner]}
        >
          <span aria-hidden="true" />
        </button>
      ))}
    </>
  );
};
